export const questions = [
  {
    title: "Where do most of your brand and creative assets live today?",
    options: [
      { text: "Shared drives, local folders, email chains", score: 0 },
      { text: "A mix of shared drives and a point tool or two", score: 1 },
      { text: "An existing DAM, but adoption is inconsistent", score: 2 },
      { text: "A DAM with strong adoption across teams", score: 3 },
    ],
  },
  {
    title: "How much time does your team lose each week hunting for or recreating assets?",
    options: [
      { text: "More than a day, easily", score: 0 },
      { text: "Around half a day", score: 1 },
      { text: "A couple of hours here and there", score: 2 },
      { text: "Rarely an issue", score: 3 },
    ],
  },
  {
    title: "Do you have a documented taxonomy or metadata standard?",
    options: [
      { text: "No — everyone tags (or doesn't) their own way", score: 0 },
      { text: "Informal conventions, nothing written down", score: 1 },
      { text: "Documented, but not consistently applied", score: 2 },
      { text: "Documented and enforced", score: 3 },
    ],
  },
  {
    title: "Who owns asset governance today?",
    options: [
      { text: "No one, really", score: 0 },
      { text: "Whoever is closest to the mess at the time", score: 1 },
      { text: "A team owns it, but without much authority", score: 2 },
      { text: "A clear owner with mandate and budget", score: 3 },
    ],
  },
  {
    title: "Where are you in your DAM platform journey?",
    options: [
      { text: "Not evaluating yet — just feeling the pain", score: 0 },
      { text: "Starting to evaluate vendors", score: 1 },
      { text: "Mid-evaluation, or close to signing", score: 2 },
      { text: "Already implemented, revisiting the setup", score: 3 },
    ],
  },
]
